"use client";

import { DismissableAd } from "@/components/pages/DismissableAd";
import type { PlacementDecision } from "@/lib/placements/decision";
import { Placement } from "./Placement";
import { useViewportAtLeast } from "./useViewportAtLeast";

/** Tailwind's `lg` — the width from which the module details lay out their
 *  card column beside the content. Below it the column stacks under the
 *  content, where a tall unit would only pile onto the bottom banner. */
const COLUMN_MIN = 1024;

/**
 * A filled slot IN a page's right-hand column — the module details' card
 * column, under the start card — for a page that has such a column, instead
 * of the floating unit (which would cover the purchase card there). It rides
 * the column's own stickiness: the card and the unit pin and release together.
 * Mounts on the client, from the width at which the column exists; the server
 * renders nothing, so nothing is billed for a stacked mobile layout the unit
 * is not part of. Session-dismissible like every surface; the dismiss wraps the
 * whole box, so a closed unit leaves the column exactly as it was.
 */
export function ColumnPlacement({ decision }: { decision?: PlacementDecision | null }) {
  const wide = useViewportAtLeast(COLUMN_MIN);
  if (!decision || !wide) return null;
  return (
    <DismissableAd storageKey={decision.slot}>
      <div className="lh-placement-column">
        <Placement decision={decision} />
      </div>
    </DismissableAd>
  );
}
